import { useState } from "react";
import { Row, Col, Flex, Image, Typography, Form, App, Button } from "antd";
import {
  BTN_TXT,
  GLOBAL_CONSTANTS,
  TITLE_TXT,
} from "../../constants/constants";
import VerifiedIcon from "../../assets/icons/verified-icon.svg";
import EditIcon from "../../assets/icons/edit-icon.svg";
import CustomButton from "../CustomButton/Button";
import CustomSelect from "../CustomSelect/CustomSelect";
import CustomInput from "../CustomInput/Input";
import CustomInputNumber from "../CustomInputNumber/InputNumber";
import CustomDatePicker from "../CustomDatePicker/CustomDatePicker";
import CancelButton from "../CustomButton/CancelButton";
import PrimaryButton from "../CustomButton/PrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import {
  editEntDets,
  entDetailedView,
} from "../../redux/slices/enterpriseSlice";
import {
  editBusDets,
  getBusDetailedView,
  editSendOtp,
  adminEditValidateOtp,
} from "../../redux/slices/BusSlice";
import {
  editBusEntDets,
  busEntDetailedView,
} from "../../redux/slices/creditLimitSlice";
import {
  editinvestorDets,
  investorDetailedView,
} from "../../redux/slices/investorSlice";
import InfoModal from "../CustomModal/InfoModal";
import OtpContent from "../OtpContent/OtpContent";
import {
  getDownloadSuccessMessage,
  percentToDiscountRate,
} from "../../helpers/helpers";
import dayjs from "dayjs";

const { Text } = Typography;

const Detail = ({
  label,
  name,
  placeholder,
  displayValue,
  value,
  rules,
  isVerified,
  isEditable,
  isInput,
  isNumInput,
  isTextArea,
  isDate,
  options = [],
  suffix, // <-- Add this
  entId,
  orgId,
  dealCategoryId,
  isBus,
  isInv,
  isBusEnt,
  busEntId,
  modifiedAt,
  isImg = false,
  isDownloadBtn = false,
}) => {
  const [editing, setEditing] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { editEntSaveLoading } = useSelector((state) => state?.enterprise);
  const { editSaveloading } = useSelector((state) => state?.business);
  const [imageModal, setImageModal] = useState(false);
  const [otpModal, setOtpModal] = useState({
    type: null, // email | mobile
    data: null,
  });

  const handleEdit = () => {
    let fieldValue = value;

    // if (name === "discountRate" && value !== undefined && value !== null) {
    //   fieldValue = Number(value) * 100;
    // }

    form.setFieldsValue({ [name]: fieldValue });
    setEditing(true);
  };

  const handleCancel = () => {
    setEditing(false);
    form.resetFields();
  };

  const handleSave = async (values) => {
    const dialogOpenKeys = ["phoneNumber", "email"];
    if (dialogOpenKeys.includes(name) && !entId) {
      if (name === "email") {
        setOtpModal({ type: name, data: values[name] });
        dispatch(editSendOtp({ email: values[name], orgId }));
      } else {
        setOtpModal({ type: name, data: values[name] });
        dispatch(editSendOtp({ mobile: values[name], orgId }));
      }

      return;
    }

    let fieldValue = values[name];

    // if (name === "discountRate") {
    //   fieldValue = Number(fieldValue) / 100;
    // }

    if (name === "incorporationDate") {
      fieldValue = values[name].format("YYYY-MM-DD");
    }
    if (name === "website" && fieldValue) {
      fieldValue = fieldValue.replace(/^https?:\/\//i, "");
      fieldValue = `http://${fieldValue}`;
    }
    if (name === "discountRate") {
      fieldValue = percentToDiscountRate(fieldValue);
    }

    const payload = {
      [name]: fieldValue,
    };

    let action;
    if (isBus) {
      payload.orgId = orgId;
      payload.modifiedAt = modifiedAt;
      action = editBusDets;
    } else if (isBusEnt) {
      payload.busEntId = busEntId;
      payload.modifiedAt = modifiedAt;
      action = editBusEntDets;
    } else if (isInv) {
      payload.orgId = orgId;
      action = editinvestorDets;
    } else {
      payload.entId = entId;
      action = editEntDets;
    }

    const res = await dispatch(action(payload));
    if (res.payload.statusCode === 201) {
      setEditing(false);
      form.resetFields();
      if (isBus) {
        dispatch(getBusDetailedView({ orgId, dealCategoryId }));
      } else if (isBusEnt) {
        dispatch(busEntDetailedView(busEntId));
      } else if (isInv) {
        dispatch(investorDetailedView(orgId));
      } else {
        dispatch(entDetailedView(entId));
      }
    }
  };

  const closeModal = () => {
    if (isImg && imageModal) {
      setImageModal(false);
    } else {
      setOtpModal({ type: null, data: null });
    }
  };

  const handleResendOtp = () => {
    if (otpModal.type === "email") {
      dispatch(editSendOtp({ email: otpModal.data, orgId }));
    } else {
      dispatch(editSendOtp({ mobile: otpModal.data, orgId }));
    }
  };

  const handlevalidateOtp = async (payload) => {
    const response = await dispatch(
      adminEditValidateOtp({ ...payload, orgId }),
    );

    if (response.payload.statusCode === 201) {
      closeModal();
      setEditing(false);
      form.resetFields();
      if (isBus) {
        dispatch(getBusDetailedView({ orgId, dealCategoryId }));
      } else if (isInv) {
        dispatch(investorDetailedView(orgId));
      }
    }
  };

  const handleDownloadView = async () => {
    if (isImg) {
      setImageModal(true);
    } else if (isDownloadBtn) {
      try {
        const response = await fetch(value, { mode: "cors" });
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const downloadedFileName = value.split("/").pop() || "file.pdf";
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = downloadedFileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        message.success(getDownloadSuccessMessage(downloadedFileName));
      } catch (error) {
        message.error("Failed to download PDF:", error);
      }
    }
  };

  return (
    <Row gutter={[16, 16]} className="detail-container" align="middle">
      <Col xs={10} md={6}>
        <Text className="label">{label}</Text>
      </Col>
      <Col xs={14} md={isVerified ? 12 : 15}>
        {editing ? (
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSave}
            initialValues={{ [name]: value }}
          >
            <Row gutter={[16, 16]}>
              <Col>
                {isInput ? (
                  <CustomInput
                    name={name}
                    type="text"
                    isTextArea={isTextArea}
                    placeholder={placeholder}
                    rules={rules}
                    removeHttps={true}
                    suffix={suffix}
                    className="detail-input"
                  />
                ) : isNumInput ? (
                  <CustomInputNumber
                    name={name}
                    type="text"
                    placeholder={placeholder}
                    rules={rules}
                    className="detail-input"
                  />
                ) : isDate ? (
                  <CustomDatePicker
                    name={name}
                    placeholder={placeholder}
                    rules={rules}
                    disabledDate={(current) =>
                      current && current >= dayjs().startOf("day")
                    }
                  />
                ) : (
                  <CustomSelect
                    name={name}
                    showSearch
                    placeholder={placeholder}
                    options={options}
                    rules={rules}
                    className="detail-select"
                  />
                )}
              </Col>
              <Col>
                <CancelButton
                  variant="outlined"
                  color="primary"
                  onClick={handleCancel}
                >
                  {BTN_TXT.CANCEL}
                </CancelButton>
              </Col>
              <Col>
                <PrimaryButton
                  variant="solid"
                  color="primary"
                  htmlType="submit"
                  loading={editEntSaveLoading || editSaveloading}
                >
                  {BTN_TXT.SAVE}
                </PrimaryButton>
              </Col>
            </Row>
          </Form>
        ) : isImg || isDownloadBtn ? (
          <Button
            style={{ padding: 0 }}
            type="link"
            onClick={handleDownloadView}
          >
            {isImg ? BTN_TXT.VIEW : "Download"}
          </Button>
        ) : (
          <Text className="value">
            {displayValue || value || GLOBAL_CONSTANTS.NA}
          </Text>
        )}
      </Col>
      {isVerified && (
        <Col xs={6} md={3}>
          <Flex
            align="center"
            justify="center"
            gap={5}
            className="verified-tag"
          >
            <Image src={VerifiedIcon} alt="Verified" preview={false} />
            <Text className="verified">{GLOBAL_CONSTANTS.VERIFIED}</Text>
          </Flex>
        </Col>
      )}
      <Col xs={6} md={3}>
        {isEditable && !editing && (
          <div className="edit-btn-container">
            <CustomButton
              type="text"
              icon={<Image src={EditIcon} alt="Edit" preview={false} />}
              onClick={handleEdit}
            />
          </div>
        )}
      </Col>
      {otpModal.type && (
        <InfoModal
          title={
            otpModal.type === "email"
              ? TITLE_TXT.EMAIL_OTP_VERIFY
              : TITLE_TXT.MOBILE_OTP_VERIFY
          }
          open
          onCancel={closeModal}
          centered
          content={
            <OtpContent
              validateOtp={(payload) => handlevalidateOtp(payload)}
              resendOtp={handleResendOtp}
              onClose={closeModal}
              otpType={otpModal.type}
              email={otpModal.type === "email" ? otpModal.data : null}
              mobile={otpModal.type === "phoneNumber" ? otpModal.data : null}
            />
          }
        />
      )}
      {imageModal && (
        <InfoModal
          title={label}
          open
          onCancel={closeModal}
          centered
          content={
            <Image
              src={value}
              alt={label}
              preview={false}
              style={{ maxHeight: "100%", maxWidth: "100%" }}
            />
          }
        />
      )}
    </Row>
  );
};

export default Detail;
